import React from 'react';
import { Link } from 'react-router-dom';
import './Shop.css';

function Shop() {
  const products = [
    {
      id: 'lamp-base',
      name: 'LAMP BASE',
      price: '$25 AUD',
      description: 'a versatile base for your custom lamp design'
    },
    {
      id: 'lamp-design-01',
      name: 'LAMP 01',
      price: '$90 AUD',
      description: 'a modern, minimalist lamp design with geometric patterns'
    },
    {
      id: 'lamp-design-02',
      name: 'LAMP 02',
      price: '$90 AUD',
      description: 'an organic, flowing design inspired by natural forms'
    },
    {
      id: 'lamp-design-03',
      name: 'LAMP 03',
      price: '$90 AUD',
      description: 'a contemporary design featuring interlocking geometric shapes'
    }
  ];

  return (
    <div className="shop">
      <div className="shop-header">
        <h1>SHOP</h1>
        <p>explore our collection of custom lamps and accessories</p>
      </div>
      
      <section className="shop-grid" aria-label="Product list">
        {products.map(product => (
          <article key={product.id} className="product-card" tabIndex={0} aria-label={product.name}>
            <div className="product-image"></div>
            <div className="product-info">
              <Link to={`/product/${product.id}`} className="product-title" aria-label={`View details for ${product.name}`} tabIndex={0}>
                {product.name}
              </Link>
              <p className="product-description">{product.description}</p>
              <p className="product-price">{product.price}</p>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
}

export default Shop; 